import { Menu, LogOut, UserCog } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import Sidebar from "./Sidebar";
import { useAuth } from "@/context/AuthContext";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getBranchName, getCurrentExchangeRate } from "@/integrations/supabase/services";
import NotificationsBell from "@/components/notifications/NotificationsBell";
import { translateRole } from "@/lib/translations";

const TopBar = () => {
  const { profile, signOut } = useAuth();

  const { data: branch } = useQuery({
    queryKey: ['branch', profile?.branch_id],
    queryFn: () => getBranchName(profile?.branch_id || ''),
    enabled: !!profile?.branch_id && (profile?.role === 'operator' || profile?.role === 'branch_admin'),
  });

  const { data: exchangeRate, isLoading: isLoadingExchangeRate } = useQuery({
    queryKey: ['current-exchange-rate'],
    queryFn: getCurrentExchangeRate,
  });

  return (
    <header className="border-b border-gray-200 bg-white">
      <div className="flex h-16 items-center justify-between px-4 md:px-6">
        <div className="flex items-center md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon">
                <Menu size={24} />
                <span className="sr-only">Abrir menú</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="p-0">
              <Sidebar />
            </SheetContent>
          </Sheet>
            <span className="flex items-center gap-2 ml-1"><img src="images/logo3.png" alt="Logo" style={{ height: '20px', maxWidth: 'auto' }} /></span>
        </div>
        <div className="hidden md:block">
          <h2 className="text-xl font-semibold text-gray-800">
            Gestor de Alquiler de Bicicletas
          </h2>
        </div>
        <div className="flex items-center gap-4">
          <NotificationsBell />
          <div className="flex flex-col items-end">
            <span className="text-sm font-medium">{profile?.full_name || 'Usuario'} </span>
            <span className="text-xs text-gray-500 capitalize">
              {(profile?.role === 'operator' || profile?.role === 'branch_admin') && branch && (
                <span className="text-xs text-gray-500 capitalize">{branch.name || 'Todas las sucursales'} </span>
              )}
              ({translateRole(profile?.role) || 'Rol no asignado'})
            </span>
            {isLoadingExchangeRate ? (
              <span className="text-xs">Cargando tasa...</span>
            ) : exchangeRate ? (
              <span className="text-xs">
                Tasa: <b>{exchangeRate.usd_to_bs.toFixed(2)} Bs</b>
              </span>
            ) : null}
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-8 w-8 rounded-full">
                <Avatar className="h-9 w-9">
                  <AvatarFallback className="bg-teal-100 text-teal-600">
                    {profile?.full_name ? profile.full_name.charAt(0).toUpperCase() : 'U'}
                  </AvatarFallback>
                </Avatar>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56" align="end" forceMount>
              <DropdownMenuItem asChild>
                <Link to={profile?.role === 'super_admin' ? "/users" : "/profile"} className="flex items-center">
                  <UserCog className="mr-2 h-4 w-4" />
                  <span>Perfil</span>
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={signOut} className="flex items-center">
                <LogOut className="mr-2 h-4 w-4" />
                <span>Cerrar sesión</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
